var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"margin-top":"20%"}},[_c('v-progress-circular',{attrs:{"color":"#11679a","size":70,"width":7,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }